import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Category } from '../../models/category/category.model';
import { Sales } from '../../models/sales/sales.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { DisplayCategory } from '../../models/category/DisplayCategory.model';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class CategoryService {
  private service = "api/Category"; //Controller Name
  private helperService = "api/SystemSetting"; //Controller Name
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  
  UpdateCategoriesList(categoiresList: any) { 
    return this.http.post(`${this.service}/UpdateCategoriesList`, categoiresList, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  AddParentCategory(formData: any): void {
    this.http
      .post(`${this.service}/SaveParentCategory`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/Parent-Category-List"]);
      });
  }
  AddFields(formData: any){
    return this.http
      .post(`${this.service}/AddField`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  AddSale(Sales: Sales) {
    return this.http
      .post(`${this.service}/AddSale`, Sales, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  UpdateSaleStatus(id: string) {
    return this.http.get(`${this.service}/UpdateSaleStatus?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  UpdateIsShow(id: string) {
    return this.http.get(`${this.service}/UpdateIsShow?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetSales() {
    return this.http.get(`${this.service}/GetSales`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetCategoryAndCompanySales() {
    return this.http.get(`${this.service}/GetCategoryAndCompanySales`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetMobileSales() {
    return this.http.get(`${this.service}/GetCategoryAndCompanyMobileSales`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetSaleById(id: string) {
    return this.http.get(`${this.service}/GetSaleById?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetSaleByIdImage(id: string) {
    return this.http.get(`${this.service}/GetSaleByIdImage?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  GetSaleCategoriesById(id: number) {
    return this.http.get(`${this.service}/GetSaleCategoriesById?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetSaleProductsById(id: number) {
    return this.http.get(`${this.service}/GetAllSaleProductsById?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  UpdateCategoryLevelSaleStatus(id: number) {
    return this.http.get(`${this.service}/UpdateCategoryLevelSaleStatus?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  DeleteField(id: string) {
    return this.http.delete(`${this.service}/DeleteField` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  AddSubCategory(formData: any): void {
    this.http
      .post(`${this.service}/SaveParentCategory`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
          this.router.navigate(["/Subcategory-List"]);
      });
  }

  //passing ParentCategoryID 0 to get first level categories
  GetCategoryList() {
    return this.http.get(`${this.service}/GetCategories?ParentCategoryID=0`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetCategoryListByVendor(id:number) {
    return this.http.get(`${this.service}/GetCategoriesByVendor?vendorId=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //passing ParentCategoryID 0 to get first level categories
  CategoriesSuggestions(text: string) {
    return this.http.get(`${this.service}/CategoriesSuggestions?search=` + text, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  
  GetAllCategoryList() {
    return this.http.get(`${this.service}/GetAllCategories`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetAllDisplayCategoryList() {
    return this.http.get(`${this.service}/GetActiveCategories`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetDisplaySubcategoryList() {
    return this.http.get(`${this.service}/GetDisplaySubcategories`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetSystemSettingFirstOrDefault() {
    return this.http.get(`${this.helperService}/GetSystemSettingFirstOrDefault`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //Get Generic Fields For categoryFields
  GetGenericFieldsList() {
    return this.http.get(`${this.service}/GetFields`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //Get Category Fields 
  GetCateoryFieldsList(categoryID: number) {
    return this.http.get(`${this.service}/GetCategoryFields?CategoryID=` + categoryID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetProductFieldsByCategory(categoryID: number) {
    return this.http.get(`${this.service}/GetProductFieldsByCategory?CategoryID=` + categoryID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //Get category by Parent category
  GetCategoryListByParent(parentCategoryID: number) {
    return this.http.get(`${this.service}/GetCategories?ParentCategoryID=` + parentCategoryID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //Add CategoryFields 
  AddCategoryFields(formData: any) {
    return this.http
      .post(`${this.service}/AddCategoryFields`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
   // getting second level categories
  GetCategoryListUnderParent() {
    return this.http.get(`${this.service}/GetCategoryListUnderParent`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  // getting third level categories
  GetSubCategoryList() {
    return this.http.get(`${this.service}/GetSubCategoryList`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetCategoryById(id: string) {
    return this.http.get(`${this.service}/GetCategoryById?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Category>response.json())
      .catch(this.errorHandler)
  }
  GetProductCategory(id: string) {
    return this.http.get(`${this.service}/GetProductCategory?ids=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Category>response.json())
      .catch(this.errorHandler)
  }
  
  GetCategoryByCategoryId(categoryID: number) {
    return this.http.get(`${this.service}/GetCategoryByCategoryId?categoryID=` + categoryID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Category>response.json())
      .catch(this.errorHandler)
  }

  DeleteCategory(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }

  //Get Category Fields 
  CheckCategoryNameExists(categoryParams: DisplayCategory) {
    return this.http.post(`${this.service}/CheckCategoryNameExists`, categoryParams, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
  ChangeStatus(id: string) {
    return this.http.get(`${this.service}/ChangeStatus?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/category/category.service.ts